var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MediaVideoList.jinja');
require('./MediaVideoList.less');

var MediaVideoListInner = require('front/components/MediaVideoList/MediaVideoListInner');

var MediaVideoListInnerTemplate = require('front/components/MediaVideoList/MediaVideoListInner.jinja');

var objectFitImages = require('object-fit-images');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MediaVideoList-btnMore': 'onClickMoreButton'
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MediaVideoListInner': {selector: '.MediaVideoListInner', viewConstructor: MediaVideoListInner}
    },

    moreApi: function () {
        return this.state[this.curCat].next;
    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);

        _.bindAll(this, 'moreApi' ,'getHash', 'onFilter', 'getAllVideos', 'getItems', 'onDropdownTitleClick', 'onBodyClick');

        this.$wrapperCats = $('.MediaVideoList-categories');
        this.$catItem = $('.MediaVideoList-category');

        this.state = {0:{
            next: Urls['front:api:media']() + '?offset=' + this.$('.MediaVideoListInner-item').size(),
            hasMore: this.$('.MediaVideoList-btnMore').is(':visible')
        }};

        this.curCat = 0;
        this.categories = _.map(this.$catItem.filter('[data-idcat!="0"]'), function (el) {
            var $el = $(el);

            return {
                'id': parseInt($el.attr('data-idcat'), 10),
                'url': $el.attr('href')
            };
        });

        _.each(this.$catItem, function (el) {
            var id = parseInt($(el).attr('data-idcat'), 10);
            if (!id) {
                return true;
            }
            this.state[id] = {
                next: Urls['front:api:media']('json') + '?category=' + id,
                hasMore: false
            };
        }.bind(this));

        // this.state[0].hasMore = window.app.data.firstHasMore;

        $(window).on('hashchange', this.getHash);
        this.getHash();

        $('.MediaVideoList-category[data-idcat="0"]').on('click', this.getAllVideos);
        $('.MediaVideoList-dropdownCategory[data-idcat="0"]').on('click', this.getAllVideos);
        $('.MediaVideoList-dropdownTitle').on('click', this.onDropdownTitleClick);
    },


    deactivate: function (params) {
        this.moreXhr && this.moreXhr.abort();

        $(window).off('hashchange', this.getHash);
        $('.MediaVideoList-category[data-idcat="0"]').off('click', this.getAllVideos);
        $('.MediaVideoList-dropdownCategory[data-idcat="0"]').off('click', this.getAllVideos);
        $('.MediaVideoList-dropdownTitle').off('click', this.onDropdownTitleClick);

        return Base.prototype.deactivate.call(this, params);
    },


    onDropdownTitleClick: function () {
        $('body').off('click', this.onBodyClick);

        if (this.$('.MediaVideoList-dropdown').hasClass('MediaVideoList-dropdown--opened')) {
            this.$('.MediaVideoList-dropdown').removeClass('MediaVideoList-dropdown--opened');
            this.$('.MediaVideoList-dropdownPanel').slideUp(200);
        } else {
            $('body').on('click', this.onBodyClick);

            this.$('.MediaVideoList-dropdown').addClass('MediaVideoList-dropdown--opened');
            this.$('.MediaVideoList-dropdownPanel').slideDown(200);
        }
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MediaVideoList-dropdown').length) return;

        this.$('.MediaVideoList-dropdown').removeClass('MediaVideoList-dropdown--opened');
        this.$('.MediaVideoList-dropdownPanel').slideUp(200);
    },


    getAllVideos: function () {
        Backbone.history.navigate(Urls['front:api:media'](), {trigger: 'true'});
        this.curCat = 0;
        this.onFilter();
    },


    getHash: function () {
        var hash = window.location.hash;

        if (!hash) {
            var previewHash =  window.app.preview && window.app.preview.split('#').pop();
            if (previewHash) {
                hash = '#' + previewHash;
            }
        }

        for (var i = 0; i < this.categories.length; i++) {
            if (hash == this.categories[i].url) {
                this.curCat = this.categories[i].id;
            }
        }

        if (hash == '') {
            this.curCat = 0;
        }

        window.app.hashMedia = hash.substr(1);

        this.onFilter();
    },

    onFilter: function () {
        var self = this;

        this.$catItem.removeClass('MediaVideoList-category--active');
        this.$('.MediaVideoList-category[data-idcat="' + this.curCat + '"]').addClass('MediaVideoList-category--active');

        this.$('.MediaVideoList-dropdownCategory').removeClass('MediaVideoList-dropdownCategory--active');
        this.$('.MediaVideoList-dropdownCategory[data-idcat="' + this.curCat + '"]').addClass('MediaVideoList-dropdownCategory--active');

        var categoryName = this.$('.MediaVideoList-dropdownCategory[data-idcat="' + this.curCat + '"]').text();
        this.$('.MediaVideoList-dropdownTitle').text(categoryName);

        this.$('.MediaVideoList-dropdown').removeClass('MediaVideoList-dropdown--opened');
        this.$('.MediaVideoList-dropdownPanel').slideUp(200);

        var $curWrapper = this.$('.MediaVideoList-list-videos[data-idcat="' + this.curCat + '"]');

        if ($curWrapper.children().length) {
            this.$('.MediaVideoList-btnMore').toggle(!!this.state[this.curCat].hasMore);

            this.$('.MediaVideoList-list-videos.active').removeClass('active');
            $curWrapper.addClass('active');
        } else {
            this.getItems($curWrapper);
        }
    },

    onClickMoreButton: function () {
        var self = this;
        this.$('.MediaVideoList-btnMore').addClass('Button--loading');

        var $curWrapper = this.$('.MediaVideoList-list-videos[data-idcat="' + this.curCat + '"]');

        this.getItems($curWrapper);
    },

    getItems: function ($curWrapper) {
        var self = this;

        this.moreXhr && this.moreXhr.abort();

        this.moreXhr = $.ajax({
            type: 'GET',
            url: this.moreApi(),
            dataType: 'json',
            success: function (data) {
                //do not reset url, important for case if no items in category at all
                if (data.next) {
                    self.state[self.curCat].next = data.next;
                }

                var $videoList = $(MediaVideoListInnerTemplate.render({data: {list: data.results}}));
                self.state[self.curCat].hasMore = !!data.next;

                self.$('.MediaVideoList-btnMore').toggle(!!self.state[self.curCat].hasMore);

                $curWrapper.append($videoList);
                self.$('.MediaVideoList-list-videos.active').removeClass('active');
                $curWrapper.addClass('active');

                app.animateShowMoreSlideDown({$items: $videoList});

                new MediaVideoListInner({
                    el: $videoList[0]
                });

                self.$('.MediaVideoList-btnMore').removeClass('Button--loading');

                window.app.utils.updateLinksAttributes($curWrapper);

                objectFitImages();
            },
            error: function (data, tp) {

            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MediaVideoList/MediaVideoList.js
// module id = 185
// module chunks = 0